/**
 * Transforms a trip from API into a Trip
 *
 * In contrast to the normal "transformTrip", the data comes from an already booked offer.
 * In this case, the source of covered legs (EPR) is different. We dont pass an offer along.
 * Also, we dont care about "isDisabled", "isDiscounted" etc.
 *
 * This is used to show an already booked trip in the booking overview.
 *
 * @param trip Trip from API
 * @param coveredLegIds List of leg IDs that are covered by the booked offer
 * @returns Transformed Trip
 */
export default function transformBookedTrip(trip: ApiSchema['Trip'], coveredLegIds: string[] = []): Trip | undefined {
    if (!trip) {
        return undefined;
    }

    // Trip ID
    const id = trip.id;

    // Transform the trip's origin and destination stop places
    const origin = transformPlace(trip.origin as ApiSchema['StopPlaceRef']);
    const destination = transformPlace(trip.destination as ApiSchema['StopPlaceRef']);

    // Extract the trip's departure and arrival times
    const departureTime = zurichDate(trip.startTime);
    const arrivalTime = zurichDate(trip.endTime);

    // Transform the trip's legs
    const legs = transformTripLegs(trip.legs, coveredLegIds);

    // If the trip is "routeOnly", all timetable info needs to be ignored/hidden, as only the route is reliable"
    const isRouteOnly = trip.type === 'ROUTE_ONLY';

    return {
        id,
        origin,
        destination,
        departureTime,
        arrivalTime,
        legs,
        isRouteOnly,
    };
}
